import * as React from 'react'

import useWorkflowsByIds from '~/client/src/shared/hooks/useWorkflowsByIds'
import { DASH, NO_VALUE } from '~/client/src/shared/utils/usefulStrings'

import { FIELDS_AND_NOTE_SEPARATOR } from '../../DeliveryDetails/DeliveryDetails.store'
import { LINKED_WORKFLOW_START_LINE } from '../WorkflowCreationForm.store'

const SEPARATOR_SIGN = ' -> '
const ALL_DASHES = [DASH, NO_VALUE]

interface IProps {
  message: string
  projectId: string
}

export default function ResolvedChangedMessage({ message, projectId }: IProps) {
  const [fieldLines, messageNote] = message.split(FIELDS_AND_NOTE_SEPARATOR)
  const changedFieldLines = fieldLines.split('\n').filter(line => line.trim())

  // Extract Linked workflow lines and collect workflow IDs to resolve
  const linkedWorkflowLines = changedFieldLines.filter(line =>
    line.startsWith(LINKED_WORKFLOW_START_LINE),
  )
  const idsToResolve: Map<string, string> = new Map()
  linkedWorkflowLines.forEach(line => {
    const ids = getWorkflowIds(line)
    ids.forEach(id => idsToResolve.set(id, id))
  })

  const { workflows } = useWorkflowsByIds(
    projectId,
    Array.from(idsToResolve.keys()),
    true,
  )
  const workflowCodesMap = workflows.reduce((map, w) => {
    map[w.id] = w.code
    return map
  }, {})

  const renderFieldName = (line: string, idx: number) => {
    let fieldName = line

    if (fieldName?.startsWith(LINKED_WORKFLOW_START_LINE)) {
      const ids = getWorkflowIds(line, false)
      const codes = ids.map(id => workflowCodesMap[id] || DASH)
      fieldName =
        LINKED_WORKFLOW_START_LINE +
          ': ' +
          codes[0] +
          SEPARATOR_SIGN +
          codes[1] || fieldName
    }

    return (
      <span key={idx} className="changed-status-message text grey large italic">
        <span className="changed-status-message-old-value" title={fieldName}>
          {fieldName}
        </span>
      </span>
    )
  }

  return (
    <>
      {changedFieldLines.map((line, i) => renderFieldName(line, i))}
      {messageNote}
    </>
  )
}

function getWorkflowIds(line: string, shouldFilter: boolean = true): string[] {
  const index = LINKED_WORKFLOW_START_LINE.length + 1
  const lineToProcess = line.substring(index)
  return lineToProcess
    .split(SEPARATOR_SIGN)
    .map(x => x.trim())
    .filter(x => !shouldFilter || (x && !ALL_DASHES.includes(x)))
}
